<template>
  <div class="company-detail-wrapper">

    <Head :title="$tc('header.companyinfo')" />
    <div class="company-detail-inner" v-if="detailData">
      <div class="banner">
        <img :src="detailData.logo" alt="">
        <div>{{detailData.name}}</div>
      </div>
      <div class="info">
        <h4>企业简介</h4>
        <p v-html="filterContent(detailData.brief)"></p>
      </div>
    </div>
    <Empty :emptydata="emptydata" v-if="emptydata" />
  </div>
</template>

<script>

import { mapState, mapMutations } from 'vuex'

import Filters from '@/utils/filters'

export default {
  name: 'CompanyDetail',
  data () {
    return {
      detailData: null,
      emptydata: null
    }
  },
  computed: {
    ...mapState(['lang'])
  },
  beforeRouteUpdate (to, from, next) {
    const lan = to.query.lan || 'zh'
    if (lan !== this.lang) {
      this.$router.push({
        path: '/',
        query: {
          lan
        }
      })
    }
  },
  created () {
    this.detailData = this.$route.query
    this.setShowLoading(false)
  },
  mounted () {
    this.$Common.track('load', {
      name: '企业详情页',
      id: this.detailData.id,
      type: '企业'
    })
  },
  beforeRouteLeave (to, form, next) {
    this.$Common.track('unload', {
      name: '企业详情页',
      id: this.detailData.id,
      type: '企业'
    }).then(() => {
      next()
    })
  },
  methods: {
    ...mapMutations(['setShowLoading']),

    filterContent (data) {
      return Filters.filterContent(data)
    }
  }
}
</script>

<style lang="scss">
.company-detail-wrapper {
  font-size: 0;
  .banner {
    text-align: center;
    img {
      width: 26.667vw;
      height: 26.667vw;
      border-radius: 50%;
      margin-bottom: 4vw;
      margin-top: 8vw;
    }
    div {
      font-size: 5.867vw;
      font-weight: 600;
      color: rgba(0, 0, 0, 0.85);
      line-height: 8vw;
      padding: 0 1em;
    }
  }
  .info {
    padding: 4.167vw 0 6.481vw;
    h4 {
      color: rgba(0, 0, 0, 0.85);
      font-size: 4.267vw;
      font-weight: 600;
      color: rgba(0, 0, 0, 0.85);
      line-height: 1;
      margin-bottom: 4vw;
      word-wrap: break-word;
      border-left: 1.067vw solid #2b50d3;
      margin-left: 4vw;
      &::before {
        content: "";
        width: 0.926vw;
        height: 3.611vw;
        background-color: #013291;
        margin-right: 1.852vw;
        flex-shrink: 0;
      }
    }
    span {
      color: #050505;
      font-size: 3.519vw;
      padding: 0 6.667vw;
      line-height: 1.4;
      display: block;
      font-weight: bold;
      margin-bottom: 2.778vw;
      word-wrap: break-word;
    }
    p {
      font-size: 3.733vw;
      font-weight: 400;
      color: rgba(0, 0, 0, 0.45);
      line-height: 5.333vw;
      word-wrap: break-word;
      padding: 0 7.467vw 8vw;
    }
  }
}
</style>
